var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7386 4.48592C19.7526 4.68279 19.7526 4.87969 19.7526 5.07656C19.7526 11.0812 15.2158 18 6.92388 18C4.36929 18 1.99621 17.2547 0 15.961C0.362958 16.0031 0.711909 16.0172 1.08883 16.0172C3.19667 16.0172 5.13706 15.3 6.68656 14.0766C4.70432 14.0344 3.04314 12.7266 2.4708 10.9266C2.75001 10.9687 3.02918 10.9969 3.32236 10.9969C3.72717 10.9969 4.13202 10.9406 4.5089 10.8422C2.44291 10.4203 0.893367 8.59218 0.893367 6.38437V6.32814C1.4936 6.66564 2.19163 6.87657 2.93143 6.90467C1.71695 6.08902 0.921297 4.69685 0.921297 3.12184C0.921297 2.27811 1.14461 1.50467 1.53549 0.829666C3.75505 3.58591 7.09138 5.38588 10.8325 5.58279C10.7627 5.24529 10.7208 4.89376 10.7208 4.54219C10.7208 2.03904 12.731 0 15.2297 0C16.5279 0 17.7005 0.548436 18.5241 1.43437C19.5431 1.23751 20.5203 0.857802 21.3858 0.337502C21.0507 1.39221 20.3388 2.27815 19.4036 2.84061C20.3109 2.74222 21.1904 2.48904 22 2.13752C21.3859 3.03748 20.6181 3.83901 19.7386 4.48592Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBw);
export default __webpack_public_path__ + "static/media/twitter-bw.d28b194e9b382ccffd0740e1aee3b7b9.svg";
export { ForwardRef as ReactComponent };